export default __webpack_public_path__ + "static/media/cloud-2.84659f6b.webp";